import { useCallback } from 'react';

import { useDebitAccountsQuery } from '@/react-query/hooks/query/accounts/use-debit-accounts';

import { useLinkProducer } from '@domain/app';
import { useOrderAvailableAccounts } from '@hooks/account/use-order-available-accounts';
import useBankAllowedOperations from '@hooks/use-bank-allowed-operations';
import { getOrderCardUrl } from '@utils/url/get-url-utils';

export const useOrderNewDebitCardUrl = () => {
    const { canOrderCard } = useBankAllowedOperations();
    const orderAvailableAccounts = useOrderAvailableAccounts();
    const linkProducer = useLinkProducer();

    const select = useCallback((): string | undefined => {
        if (!canOrderCard) {
            return undefined;
        }

        if (typeof orderAvailableAccounts === 'undefined' || orderAvailableAccounts.length === 0) {
            return undefined;
        }

        return getOrderCardUrl(linkProducer);
    }, [canOrderCard, linkProducer, orderAvailableAccounts]);

    return useDebitAccountsQuery({
        select,
    });
};
